import socialsPlatform from "fragments/socialsPlatform"
import gql from "graphql-tag"

const SOCIALS_PLATFORM_ADD = gql`
  ${socialsPlatform}

  mutation socialsPlatformAdd(
    $socialsPlatformAddInput: SocialsPlatformAddInput!
  ) {
    socialsPlatformAdd(socialsPlatformAddInput: $socialsPlatformAddInput) {
      ...SocialsPlatform
    }
  }
`

export default SOCIALS_PLATFORM_ADD
